import { useMutation, useQueryClient } from "@tanstack/react-query";
import { editLeave } from "../api";
import { EditLeaveFormValues } from "../schema";
import { toast } from "react-toastify";

export const useEditLeave = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      values,
    }: {
      id: string;
      values: Partial<EditLeaveFormValues>;
    }) => editLeave({ id, values }),
    onSuccess: () => {
      toast.success("Updated Successfully!")
    },
    onError: () => {
      toast.error("Failed to update!");
    },
  });
};
